// extracted by mini-css-extract-plugin
export var callCard = "_ox-0";
export var callMessageButton = "_ox-1";
export var helpIcon = "_ox-3";
export var helpIconContainer = "_ox-4";
export var verticalDivider = "_ox-2";